import React from 'react';
import { Route, IndexRoute } from 'react-router';
import App from '../containers/App';
import AdminWrapper from '../containers/AdminWrapper';
import FederationWrapper from '../containers/FederationWrapper';
import {
  LoginPage,
  IsLoggedIn as isLoggedIn,
  IsAdmin as isAdmin,
  IsFederation as isFederation,
  IsVisitor as isVisitor,
} from '../containers/auth';
import { Horses } from '../components';
import { UserManagement } from '../components/user';
import { EntryManagement, PublicEntryPage } from '../components/entry';
import { HorseManagement } from '../components/horse';

export default (
  <Route path="/" component={App}>
    <IndexRoute component={isVisitor(PublicEntryPage)} />

    <Route path="/login" component={isVisitor(LoginPage)} />

    <Route component={isLoggedIn(isAdmin(AdminWrapper))}>
      <Route path="/admin" component={UserManagement} />
      <Route path="/admin/entries(/:nation)" component={EntryManagement} />
      <Route path="/admin/horses" component={Horses} />
    </Route>

    <Route component={isLoggedIn(isFederation(FederationWrapper))}>
      <Route path="/federation" component={EntryManagement} />
      <Route path="/federation/all-entries" component={PublicEntryPage} />
      <Route path="/federation/additional-horses" component={HorseManagement} />
    </Route>
  </Route>
);



// WEBPACK FOOTER //
// ./src/routes/index.js